import { SVGProps } from "react";

export default function LocationCheckIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#545454", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.71094 9.58333L8.96094 10.8333L12.2943 7.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.98412 3.58338C8.62578 0.158384 15.6841 1.33338 16.9841 7.09172C17.9424 11.3251 15.3091 14.9084 13.0008 17.1251C11.3258 18.7417 8.67578 18.7417 6.99245 17.1251C4.69245 14.9001 2.05078 11.3167 3.01745 7.08338"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
